import { userService } from "../services/user.services";

const refreshIdToken = async () => {
    
    const response = await userService.RefreshToken();
    if (response?.error === false && response?.data?.success_status === true) {
        sessionStorage.setItem('IdToken', response.data.data);
    } else {
        if(response?.message?.response?.status===400){
            const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
            localStorage.setItem('custom-status', 'inactive');
            sessionStorage.clear();
            sessionStorage.getItem('IdToken')?localStorage.clear():''
            localStorage.setItem("custom-status",'inactive')
            localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            window.location.href = '/';
        }
    }
}

export default refreshIdToken;